import { AvailableTabs } from 'constants/SidebarTabs';
import { NormalizedLoad } from 'types/Load';

import { TMSHost } from './interface';

export class Turvo implements TMSHost {
  getFieldMoniker(key: keyof NormalizedLoad): string {
    switch (key) {
      case 'externalTMSID':
        return '';
      case 'freightTrackingID':
        return 'PRO #';
      default:
        return '';
    }
  }

  parseFreightTrackingID(): string {
    return '';
  }

  parseExternalTMSID(): string {
    return '';
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    return location.href.includes('turvo.com');
  }
}
